import { Block } from 'baseui/block';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { styled } from 'baseui';
import Plus from 'baseui/icon/plus';
import React from 'react';
import { EditModeInput } from '../common/Input';
import type { FollowUpType, QnAStateType } from '../../reducers';
import { addNewAndCondition, addNewOrCondition, deleteCondition, updateCondition } from '../../utils/question';
import { getQuestionById, possibleQuestionForFollowUpConditionSelector } from '../../reducers/selectors';
import Condition from './Condition';
const ConditionList = styled<'ol', {}>('ol', ({
  $theme
}) => ({
  padding: '0 0 5px',
  margin: 0,
  border: `1px solid ${$theme.colors.borderTransparent}`
}));
const ConditionItem = styled<typeof Block, any>(Block, ({
  $theme
}: {
  $theme: any;
}) => ({
  display: 'block',
  margin: 0,
  background: $theme.colors.backgroundPrimary,
  color: $theme.colors.primaryA
}));
const ConditionORItem = styled(ConditionItem, {
  padding: '5px 5px 0',
  margin: 0
});
const ConditionANDItem = styled(ConditionItem, {
  padding: '4px'
});
const AndOrLabel = styled('div', ({
  $theme
}) => ({
  textAlign: 'center',
  paddingLeft: $theme.sizing.scale500
}));
const Conditions = ({
  state,
  updateQuestion,
  followUp,
  followUpIdx,
  followUpOwnderId,
  editMode,
  setEditMode
}: {
  state: QnAStateType;
  updateQuestion: Function;
  followUp: FollowUpType;
  followUpIdx: number;
  followUpOwnderId: string;
  editMode: boolean;
  setEditMode: Function;
}) => {
  const conditions = get(followUp, 'conditions');
  const questionId = get(followUp, 'questionId');
  if (!editMode && isEmpty(conditions)) {
    return <span>Click here to start adding conditions</span>;
  }
  const ownerQuestion = getQuestionById(state, followUpOwnderId);
  const possibleQuestions = possibleQuestionForFollowUpConditionSelector(state, questionId);
  const defaultConditionQuestionId = get(possibleQuestions, '0.value');
  const defaultConditionQuestion = getQuestionById(state, defaultConditionQuestionId);
  const defaultConditionQuestionAnswer = get(defaultConditionQuestion, 'answers.0.answer');
  const newCondition = {
    id: defaultConditionQuestionId,
    answer: defaultConditionQuestionAnswer
  };
  return <ConditionList>
      {!isEmpty(conditions) && conditions.map((ORs, orIdx) => {
      return <ConditionORItem as="li" key={orIdx}>
                <ConditionList>
                  {!isEmpty(ORs) && ORs.map((AND, andIdx) => <ConditionANDItem as="li" key={`${orIdx}-${andIdx}`}>
                        <Condition state={state} condition={AND} editMode={editMode} targetQuestionId={questionId} onDelete={() => {
              const nextQuestion = deleteCondition(ownerQuestion, followUpIdx, orIdx, andIdx);
              updateQuestion(nextQuestion);
            }} onChange={updatedCondition => {
              const nextQuestion = updateCondition(ownerQuestion, updatedCondition, followUpIdx, orIdx, andIdx);
              updateQuestion(nextQuestion);
            }} />
                      </ConditionANDItem>
          // @ts-expect-error todo(ts-migration) TS2322 Type 'Element[]' is not assignable to type 'Element'.
          ).reduce((prev, comp, andIdx) => [prev, <AndOrLabel key={`label-${orIdx}-${andIdx}`}>AND</AndOrLabel>, comp])}
                  <EditModeInput editMode={editMode} hideNoneEdit>
                    <ConditionANDItem as="li" onClick={() => {
              const nextQuestion = addNewAndCondition(ownerQuestion, newCondition, followUpIdx, orIdx);
              updateQuestion(nextQuestion);
            }} style={{
              cursor: 'pointer'
            }}>
                      <Plus /> AND condition
                    </ConditionANDItem>
                  </EditModeInput>
                </ConditionList>
              </ConditionORItem>;
    })
    // @ts-expect-error todo(ts-migration) TS2739 Type 'Element[]' is missing the following properties from type 'Element': type, props, key
    .reduce((prev, comp, orIdx) => [prev, <AndOrLabel key={`label-${orIdx}`}>OR</AndOrLabel>, comp])}
      <ConditionORItem as="li">
        <ConditionList>
          <EditModeInput editMode={editMode} hideNoneEdit>
            <ConditionANDItem as="li" onClick={() => {
            const nextQuestion = addNewOrCondition(ownerQuestion, newCondition, followUpIdx);
            updateQuestion(nextQuestion);
          }} style={{
            cursor: 'pointer'
          }}>
              <Plus /> OR condition
            </ConditionANDItem>
          </EditModeInput>
        </ConditionList>
      </ConditionORItem>
    </ConditionList>;
};
export default Conditions;